module.exports = __webpack_public_path__ + "e3b31e85e1f8ffd866899ca9e382d30a.glb";